
/**
 * Remove the given needle from the start and the end of string
 * 
 * @param {string} value 
 * @param {string} needle 
 * @returns {string}
 */
export default function trim(value: string, needle: string = ' ') {
    const pattern = '^' + needle + '+|' + needle + '+$'

    return value.replace(new RegExp(pattern, 'g'), "")
}